import { render, staticRenderFns } from "./SettingsButton.vue?vue&type=template&id=5dc89e26&scoped=true"
import script from "./SettingsButton.vue?vue&type=script&lang=js"
export * from "./SettingsButton.vue?vue&type=script&lang=js"
import style0 from "./SettingsButton.vue?vue&type=style&index=0&id=5dc89e26&prod&scoped=true&lang=scss"
import style1 from "./SettingsButton.vue?vue&type=style&index=1&id=5dc89e26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc89e26",
  null
  
)

export default component.exports